export const APPLICANT = 'applicant';

export const RECRUITER = 'recruiter';

export const FREELANCER = 'freelancer';

export const REPRESENTATIVE = 'representative';

export const ADMIN = 'admin';
